export const ANDROID_PACKAGE_ID = 'com.optimizeware.morafaa';

export const PLAY_STORE_URL =
  `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE_ID}`;

/** Meta / paid ads land here before Play Store handoff. */
export const DOWNLOAD_ANDROID_PATH = '/download-android';

export const DOWNLOAD_ANDROID_BASE_URL =
  `https://morafaa.web.app${DOWNLOAD_ANDROID_PATH}`;

/**
 * Builds a Play Store URL, forwarding the current page query string as a
 * Play Install Referrer when present (UTM from Meta ads).
 */
export function buildPlayStoreUrl(search: string): string {
  const params = new URLSearchParams(search);
  if (params.toString() === '') {
    return PLAY_STORE_URL;
  }
  const referrer = encodeURIComponent(params.toString());
  return `${PLAY_STORE_URL}&referrer=${referrer}`;
}

/** Android market:// deep link — more reliable from Meta in-app browser. */
export function buildMarketUrl(search: string): string {
  const params = new URLSearchParams(search);
  const base = `market://details?id=${ANDROID_PACKAGE_ID}`;
  if (params.toString() === '') {
    return base;
  }
  const referrer = encodeURIComponent(params.toString());
  return `${base}&referrer=${referrer}`;
}

export function isAndroidDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent);
}

/**
 * Redirect to Play Store. Tries market:// on Android (Meta IAB), then HTTPS fallback.
 * Never throws.
 */
export function redirectToPlayStore(search: string): void {
  const httpsUrl = buildPlayStoreUrl(search);

  if (!isAndroidDevice()) {
    window.location.replace(httpsUrl);
    return;
  }

  const marketUrl = buildMarketUrl(search);
  window.location.href = marketUrl;

  window.setTimeout(() => {
    window.location.replace(httpsUrl);
  }, 1200);
}
